import React, { useEffect, useState } from "react"

import MetaInfo from "../components/MetaInfo";
import Header from "../components/Header";
import Footer from "../components/Footer";

import visitorsImage from "../assets/img/leadership/Hon’ble Shri Raman Deka.png";
import patronsImage from "../assets/img/leadership/Shri Mahesh Agrawal.png";
import chancellorImage from "../assets/img/leadership/Dr. Vinay M. Agrawal.webp";
import viceChancellorImage from "../assets/img/leadership/Prof. (Dr.) Anand Mahalwar.webp";
import registrarImage from "../assets/img/leadership/Dr. B.P. Bhol.png";

import { Title, Eyebrow, Arrow, CrestMark } from "../components/CommonComponents";

const leaders = [
    {
        number: "01",
        role: "Hon'ble Visitor",
        name: "Hon’ble Shri Raman Deka",
        image: visitorsImage,
        alt: "Hon’ble Shri Raman Deka, Visitor, ISBM University",

        href: "/honorable-visitor",

        summary:
            "The Hon’ble Visitor provides distinguished guidance to the University and represents a commitment to responsible public leadership, educational progress and inclusive development.",

        messageTitle: "Hon'ble Visitor",

        message: [
            "Hon’ble Shri Raman Deka Ji serving as the Governor of Chhattisgarh, bringing with him a wealth of experience and dedication to public service. As a prominent political leader, Shri Raman Deka Ji has a distinguished career, marked by his commitment to the development and welfare of the people. His tenure as Governor is characterized by initiatives aimed at improving governance, enhancing infrastructure, and fostering economic growth in the state.",

            "Shri Raman Deka Ji leadership is pivotal in addressing key issues such as education, healthcare, and rural development, ensuring that the benefits of progress reach every segment of society. His collaborative approach with various stakeholders, including government officials, industry leaders, and civil society, underscores his vision of a prosperous and inclusive Chhattisgarh.",
        ],
    },

    {
        number: "02",
        role: "Hon'ble Patron",
        name: "Shri Mahesh Agrawal",
        image: patronsImage,
        alt: "Shri Mahesh Agrawal, Patron, ISBM University",

        href: "/honorable-patron",

        summary:
            "As Hon’ble Patron, Shri Mahesh Agrawal supports ISBM University’s commitment to accessible, relevant education that develops knowledgeable, skilled and responsible graduates.",

        messageTitle: "Patron's Message",

        message: [
            "ISBM University was established in the year 2016 with an objective to cater the multifaceted educational needs of the millions.",

            "Its philosophy includes offering multiple courses and programmes for the students, preparing them to become successful in life and eventually to become responsible citizens of the country.",

            "We encourage them to develop their personality, by metamorphosing and nurturing them to become employable as well as venture into entrepreneurship.",

            "In a nutshell, we take all our efforts for academic growth & skill development of the students.",
        ],
    },

    {
        number: "03",
        role: "Hon'ble Chancellor",
        name: "Dr. Vinay M. Agrawal",
        image: chancellorImage,
        alt: "Dr. Vinay M. Agrawal, Chancellor, ISBM University",

        href: "/honorable-chancellor",

        summary:
            "The Chancellor provides strategic direction to the University, championing education as a force for empowerment, innovation and social progress.",

        messageTitle: "From The Chancellor's Desk",

        message: [
            "Education is an intervention in the modern society where, harmonious development can be achieved by enlightenment of an individual's heart, mind and soul.",

            "I am of the opinion that education can transform the attitude, thought process and lifestyle of the people leading to the development of the society Education makes people flexible in thinking rationally and making appropriate decisions.",

            "I have always worked towards empowering the mass. Education serves as the tool & technique of empowerment with skilled and socially relevant citizens.",
        ],
    },

    {
        number: "04",
        role: "Hon'ble Vice Chancellor",
        name: "Prof. (Dr.) Anand Mahalwar",
        image: viceChancellorImage,
        alt: "Prof. Dr. Anand Mahalwar, Vice Chancellor, ISBM University",

        href: "/honorable-vice-chancellor",

        summary:
            "The Vice Chancellor leads the University's academic mission with a focus on research-driven, skill-based and knowledge-intensive learning.",

        messageTitle: "From The Vice Chancellor's Desk",

        message: [
            "The University is a new-age University committed to provide innovative learning programmes to meet the current requirements of the society & industry. The programmes offered are research driven, skill based and knowledge intensive.",

            "The University is envisioned to be a centre of academic innovation and research where students and faculty will collaborate together to learn, research, create, innovate, inspire and incubate",

            "The University endeavors to offer services across the student-life cycle, supporting students not only with teaching and learning, but also with career development, skill enhancement, employment opportunities, business incubation, fund raising, and mentoring.",
        ],
    },

    {
        number: "05",
        role: "Registrar",
        name: "Dr. B.P. Bhol",
        image: registrarImage,
        alt: "Dr. B.P. Bhol, Registrar, ISBM University",

        href: "/honorable-registrar",

        summary:
            "The Registrar supports University administration, academic coordination and student services while strengthening institutional quality and opportunity.",

        messageTitle: "From Registrar's Desk",

        message: [
            "On behalf of the Administration, faculty, and staff of ISBM University. I am pleased to extend a warm welcome to all of you.",

            "Education is a powerful tool that can break down the barriers to development, and higher education equips individuals with the ability to make better choices, gain access to economic stability, and achieve financial security. Our university is dedicated to providing quality education through the use of the latest technology and high academic standards.",

            "We have an excellent team of highly qualified, committed, and friendly staff members who are here to support our students and provide them with the best education possible. Our faculty members are also committed to advising and working with students to help them achieve their academic and professional goals.",

            "At ISBM University, we are committed to providing our students with improved career opportunities and greater socio-cultural awareness through our comprehensive curricular, co-curricular, and extra-curricular activities.",
        ],
    },
];

const governance = [
    {
        index: "01",
        title: "Governing Body",
        text: "The University's principal decision-making body, responsible for strategic oversight, resource deployment and institutional development.",
        href: "/governing-body",
    },
    {
        index: "02",
        title: "Board of Management",
        text: "A statutory body supporting University management, appointments, programme administration and implementation of approved institutional decisions.",
        href: "/board-management",
    },
    {
        index: "03",
        title: "Academic Council",
        text: "The academic body that coordinates and supervises University policies, programmes, research direction and academic standards.",
        href: "/academic-council",
    },
];

function CloseIcon({ className = "" }) {
    return (
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className={className}>
            <path d="M6 6l12 12M18 6 6 18" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
        </svg>
    );
}

function LeaderMessageModal({ leader, onClose }) {
    if (!leader) return null;

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 sm:p-6" role="dialog" aria-modal="true" aria-labelledby="leader-message-title">
            <button type="button" aria-label="Close message" onClick={onClose} className="absolute inset-0 bg-[#071A2F]/80 backdrop-blur-[3px]" />

            <div className="relative z-10 flex max-h-[90vh] w-full max-w-5xl flex-col overflow-hidden bg-white shadow-[0_32px_100px_rgba(0,0,0,.38)] lg:grid lg:grid-cols-[410px_1fr]">
                <div className="relative hidden min-h-[560px] overflow-hidden bg-[#EAE5DA] lg:block">
                    <img src={leader.image} alt={leader.alt} className="absolute inset-0 h-full w-full object-cover object-top" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#071A2F]/85 via-[#071A2F]/10 to-transparent" />
                    <div className="absolute inset-x-0 bottom-0 p-8 text-white">
                        <p className="text-[10px] font-semibold uppercase tracking-[0.28em] text-[#D5AD57]">{leader.role}</p>
                        <h3 className="mt-3 font-serif text-3xl leading-tight">{leader.name}</h3>
                    </div>
                </div>

                <div className="flex min-h-0 flex-1 flex-col">
                    <div className="flex items-start justify-between gap-6 border-b border-[#071A2F]/10 px-6 py-5 sm:px-8 lg:px-10 lg:py-7">
                        <div>
                            <p className="text-[10px] font-semibold uppercase tracking-[0.28em] text-[#A77B2D]">Leadership Message</p>
                            <h2 id="leader-message-title" className="mt-2 font-serif text-3xl leading-tight tracking-[-0.025em] text-[#071A2F] sm:text-4xl">{leader.messageTitle}</h2>
                            <p className="mt-2 text-sm font-semibold text-[#8B1E3F] lg:hidden">{leader.name}</p>
                        </div>

                        <button type="button" onClick={onClose} aria-label="Close message" className="grid h-11 w-11 shrink-0 place-items-center border border-[#071A2F]/10 text-[#071A2F] transition hover:border-[#8B1E3F]/30 hover:bg-[#F7F2E8] hover:text-[#8B1E3F]">
                            <CloseIcon className="h-5 w-5" />
                        </button>
                    </div>

                    <div className="overflow-y-auto px-6 py-7 sm:px-8 lg:px-10 lg:py-9">
                        <div className="space-y-5 border-l-2 border-[#D5AD57] pl-5 sm:pl-7">
                            {leader.message.map((paragraph) => (
                                <p key={paragraph} className="text-[15px] leading-8 text-[#4F5D70] sm:text-base">{paragraph}</p>
                            ))}
                        </div>

                        <div className="mt-9 flex items-center gap-4 border-t border-[#071A2F]/10 pt-6">
                            <span className="h-px w-10 bg-[#D5AD57]" />
                            <div>
                                <p className="font-serif text-xl text-[#071A2F]">{leader.name}</p>
                                <p className="mt-1 text-[10px] font-semibold uppercase tracking-[0.24em] text-[#8B1E3F]">{leader.role} · ISBM University</p>
                            </div>
                        </div>

                        <div className="mt-8 border-t border-[#071A2F]/10 pt-6">
                            <a target="_blank" href={leader.href} className="group inline-flex min-h-[52px] items-center justify-between gap-10 bg-[#071A2F] px-6 text-sm font-semibold text-white transition hover:bg-[#8B1E3F]">
                                View Full Profile
                                <span className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1">
                                    ↗
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default function LeadershipManagement() {
    const [selectedLeader, setSelectedLeader] = useState(null);

    useEffect(() => {
        if (!selectedLeader) return undefined;

        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";

        const handleEscape = (event) => {
            if (event.key === "Escape") setSelectedLeader(null);
        };

        window.addEventListener("keydown", handleEscape);

        return () => {
            document.body.style.overflow = previousOverflow;
            window.removeEventListener("keydown", handleEscape);
        };
    }, [selectedLeader]);
    return (
        <>
            <MetaInfo param="" id="about" />

            <Header school="common" />
            <main className="overflow-hidden bg-white text-[#132337]">
                <section className="relative isolate min-h-[60vh] overflow-hidden bg-[#071A2F] lg:min-h-[60vh]">
                    <div className="absolute inset-0 bg-[radial-gradient(circle_at_78%_18%,rgba(213,173,87,0.15),transparent_32%),radial-gradient(circle_at_12%_88%,rgba(139,30,63,0.22),transparent_36%)]" />
                    <div className="absolute inset-y-0 right-0 w-[55%] opacity-25 [background-image:linear-gradient(rgba(255,255,255,.06)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.06)_1px,transparent_1px)] [background-size:46px_46px] [mask-image:linear-gradient(to_left,black,transparent)]" />
                    <div className="absolute -right-32 -top-28 h-[520px] w-[520px] rounded-full border border-[#D5AD57]/20" />
                    <div className="absolute -right-10 top-4 h-[420px] w-[420px] rounded-full border border-white/10" />

                    <div className="grid gap-16 lg:grid-cols-[1.06fr_.94fr] mx-auto min-h-[60vh] w-[min(1380px,calc(100%-48px))] items-center pb-20 pt-[190px] max-sm:w-[calc(100%-28px)] lg:min-h-[60vh] lg:pb-24">
                        <div className="max-w-3xl">
                            <Eyebrow dark>University Leadership</Eyebrow>
                            <h1 className="mt-7 max-w-4xl font-serif text-5xl leading-[.96] tracking-[-0.045em] text-white sm:text-6xl lg:text-8xl">
                                Leadership <span className="text-[#D5AD57]">&amp;</span><br />Management
                            </h1>
                            <p className="mt-8 max-w-2xl text-base leading-8 text-white/60 sm:text-lg">
                                Purpose-led academic leadership, responsible governance and institutional stewardship shape the direction of ISBM University.
                            </p>
                            <div className="mt-10 flex flex-wrap gap-3">
                                <a target="_blank" href="#leadership" className="group inline-flex items-center gap-4 bg-[#D5AD57] px-6 py-4 text-sm font-semibold text-[#071A2F] transition hover:bg-[#E2BF71]">
                                    Meet the leadership
                                    <Arrow className="h-4 w-4 transition group-hover:translate-x-1" />
                                </a>
                                <a target="_blank" href="#governance" className="group inline-flex items-center gap-4 border border-white/20 px-6 py-4 text-sm font-semibold text-white transition hover:border-white/45 hover:bg-white/5">
                                    Explore governance
                                    <Arrow className="h-4 w-4 transition group-hover:translate-x-1" />
                                </a>
                            </div>
                        </div>

                        <div className="right-0 top-1/2 w-[100%] border border-white/12 bg-white/[0.035] p-8 backdrop-blur-sm">
                            <div className="flex items-start justify-between gap-8 border-b border-white/10 pb-10">
                                <CrestMark />
                                <div className="max-w-xs text-right">
                                    <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-[#D5AD57]">Knowledge · Wisdom · Humanity</p>
                                    <p className="mt-4 font-serif text-3xl leading-tight text-white">Leadership that keeps learning at the centre.</p>
                                </div>
                            </div>
                            <div className="grid grid-cols-3 divide-x divide-white/10 pt-8">
                                {["Academic", "Strategic", "Responsible"].map((item, index) => (
                                    <div key={item} className={index === 0 ? "pr-5" : "px-5"}>
                                        <span className="text-xs text-[#D5AD57]">0{index + 1}</span>
                                        <p className="mt-3 text-sm font-medium text-white/85">{item}<br />leadership</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>

                <section className="bg-[#F7F2E8] py-20 sm:py-24 lg:py-32">
                    <div className="mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-[.82fr_1.18fr] lg:gap-24 lg:px-10">
                        <div>
                            <Eyebrow>Leadership Philosophy</Eyebrow>
                            <Title
                                before="Guided by"
                                highlight="purpose,"
                                after="built on responsibility."
                                position="middle"
                                className="mt-6"
                            />
                        </div>
                        <div className="grid content-start gap-8 border-l border-[#071A2F]/10 pl-0 lg:pl-10">
                            <p className="max-w-2xl text-lg leading-9 text-[#425064]">
                                ISBM University's leadership brings together strategic direction, academic stewardship and responsible administration to create an environment focused on learning, research, employability and meaningful institutional growth.
                            </p>
                            <div className="grid gap-5 sm:grid-cols-3">
                                {["Academic excellence", "Student-centred growth", "Institutional integrity"].map((item, index) => (
                                    <div key={item} className="border-t border-[#071A2F]/15 pt-5">
                                        <span className="text-xs font-semibold text-[#A77B2D]">0{index + 1}</span>
                                        <p className="mt-2 text-sm font-semibold text-[#071A2F]">{item}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>

                <section id="leadership" className="py-20 sm:py-24 lg:py-32">
                    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
                        <div className="grid items-end gap-8 lg:grid-cols-[1fr_.65fr]">
                            <div>
                                <Eyebrow>University Leadership</Eyebrow>
                                <Title
                                    before="The people"
                                    highlight="guiding"
                                    after="the University forward."
                                    position="middle"
                                    className="mt-6 max-w-4xl"
                                />
                            </div>
                            <p className="max-w-xl text-base leading-8 text-[#627083] lg:justify-self-end">
                                Meet the senior leadership responsible for strategic direction, academic quality and effective University administration.
                            </p>
                        </div>

                        <div className="mt-14 space-y-5 lg:mt-18">
                            {leaders.map((leader, index) => (
                                <article key={leader.name} className="group grid overflow-hidden border border-[#071A2F]/10 bg-white transition duration-500 hover:border-[#A77B2D]/45 hover:shadow-[0_24px_70px_rgba(7,26,47,.08)] lg:grid-cols-[340px_1fr_92px]">
                                    <div className="relative min-h-[380px] overflow-hidden bg-[#EAE5DA] sm:min-h-[440px] lg:min-h-[390px]">
                                        <img src={leader.image} alt={leader.alt} className="absolute inset-0 h-full w-full object-cover object-top transition duration-700 group-hover:scale-[1.025]" />
                                        <div className="absolute inset-0 bg-gradient-to-t from-[#071A2F]/35 via-transparent to-transparent" />
                                        <span className="absolute left-5 top-5 bg-white/92 px-3 py-2 text-xs font-semibold tracking-[0.2em] text-[#071A2F] backdrop-blur">{leader.number}</span>
                                    </div>

                                    <div className="flex flex-col justify-center px-6 py-9 sm:px-10 lg:px-14 lg:py-12">
                                        <p className="text-xs font-semibold uppercase tracking-[0.24em] text-[#8B1E3F]">{leader.role}</p>
                                        <h3 className="mt-4 font-serif text-4xl leading-tight tracking-[-0.03em] text-[#071A2F] sm:text-5xl">{leader.name}</h3>
                                        <p className="mt-6 max-w-2xl text-base leading-8 text-[#627083]">{leader.summary}</p>

                                        <div className="mt-8 flex flex-wrap items-center gap-3">
                                            <a target="_blank" href={leader.href} className="group inline-flex min-h-[50px] items-center gap-8 bg-[#071A2F] px-6 text-sm font-semibold text-white transition hover:bg-[#8B1E3F]">
                                                View Profile
                                                <span className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1">↗</span>
                                            </a>

                                            <button type="button" onClick={() => setSelectedLeader(leader)} className="inline-flex min-h-[50px] items-center gap-4 border border-[#071A2F]/15 px-6 text-sm font-semibold text-[#071A2F] transition hover:border-[#8B1E3F]/40 hover:text-[#8B1E3F]">
                                                Read Message
                                                <Arrow className="h-4 w-4" />
                                            </button>
                                        </div>
                                    </div>

                                    <div className="hidden justify-center bg-[#071A2F] py-8 lg:flex">
                                        <div className="flex -rotate-90 items-center gap-3 whitespace-nowrap text-[10px] font-semibold uppercase tracking-[0.28em] text-white/65">
                                            ISBM University <span className="h-px w-12 bg-[#D5AD57]" />
                                        </div>
                                    </div>
                                </article>
                            ))}
                        </div>
                    </div>
                </section>

                <section id="governance" className="relative overflow-hidden bg-[#071A2F] py-20 sm:py-24 lg:py-32">
                    <div className="absolute -left-32 top-10 h-[520px] w-[520px] rounded-full border border-white/5" />
                    <div className="absolute -left-10 top-32 h-[360px] w-[360px] rounded-full border border-[#D5AD57]/10" />
                    <div className="relative mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
                        <div className="grid gap-10 lg:grid-cols-[.8fr_1.2fr] lg:gap-24">
                            <div>
                                <Eyebrow dark>Governance Structure</Eyebrow>
                                <Title
                                    before="Leadership"
                                    highlight="supported"
                                    after="by strong governance."
                                    position="middle"
                                    dark
                                    className="mt-6"
                                />
                                <p className="mt-7 max-w-lg text-base leading-8 text-white">
                                    Institutional decision-making is supported by statutory and academic bodies that help maintain strategic, administrative and academic oversight.
                                </p>
                            </div>

                            <div className="divide-y divide-white/10 border-y border-white/10">
                                {governance.map((item) => (
                                    <a key={item.title} href={item.href} className="group grid gap-5 py-5 transition sm:grid-cols-[60px_1fr_32px] sm:items-start sm:py-7">
                                        <span className="text-sm font-semibold text-[#D5AD57]">{item.index}</span>
                                        <div>
                                            <h3 className="font-serif text-3xl text-white sm:text-4xl">{item.title}</h3>
                                            <p className="mt-3 max-w-xl text-sm leading-7 text-white/55">{item.text}</p>
                                        </div>
                                        <Arrow className="h-5 w-5 text-white/50 transition group-hover:translate-x-1 group-hover:text-[#D5AD57]" />
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>

                <section className="bg-white py-20 sm:py-24 lg:py-28">
                    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
                        <div className="relative overflow-hidden bg-[#F7F2E8] px-6 py-12 sm:px-10 lg:px-16 lg:py-16">
                            <div className="absolute right-0 top-0 h-full w-1/3 bg-[radial-gradient(circle_at_center,rgba(213,173,87,.22),transparent_70%)]" />
                            <div className="relative grid items-center gap-8 lg:grid-cols-[1fr_auto]">
                                <div>
                                    <Eyebrow>Discover ISBM University</Eyebrow>
                                    <h2 className="mt-5 max-w-3xl font-serif text-4xl leading-tight tracking-[-0.03em] text-[#071A2F] sm:text-5xl">Explore the University, its academic vision and institutional direction.</h2>
                                </div>
                                <div className="flex flex-wrap gap-3 lg:justify-end">
                                    <a target="_blank" href="/about-us" className="inline-flex items-center gap-3 bg-[#071A2F] px-6 py-4 text-sm font-semibold text-white transition hover:bg-[#0C2744]">About the University <Arrow className="h-4 w-4" /></a>
                                    <a target="_blank" href="/vision-and-mission" className="inline-flex items-center gap-3 border border-[#071A2F]/15 bg-white px-6 py-4 text-sm font-semibold text-[#071A2F] transition hover:border-[#8B1E3F]/40 hover:text-[#8B1E3F]">Vision &amp; Mission <Arrow className="h-4 w-4" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            {selectedLeader && (
                <LeaderMessageModal leader={selectedLeader} onClose={() => setSelectedLeader(null)} />
            )}
            <Footer />
        </>
    );
}
